import * as React from "react";
import { Box } from "@mui/material";
import { Loader } from "../../components/Loader/Loader";
import { Clients } from "../About/Clients/Clients";
import { Testimonials } from "../About/Testimonials/Testimonials";
import axios from "axios";

interface Props {
  banner: string;
  setBanner: React.Dispatch<React.SetStateAction<string>>;
}

export const Brands: React.FC<Props> = ({ banner, setBanner }) => {
  const [clients, setClients] = React.useState<string[]>([]);
  const [testimonials, setTestimonials] = React.useState<string[]>([]);
  const [authors, setAuthors] = React.useState<string[]>([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let data = [];
    axios
      .get(
        "https://headless.jonvickersmedia.com/wp-json/wp/v2/brands-logo?per_page=40"
      )
      .then((res) => {
        data = res.data.reverse();
        setBanner(data[0].acf.image);
        setClients(data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  React.useEffect(() => {
    let data = [];
    axios
      .get(
        "https://headless.jonvickersmedia.com/wp-json/wp/v2/brands-testimonials?per_page=40"
      )
      .then((res) => {
        data = res.data.reverse();
        setTestimonials(data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            rowGap: "40px",
            padding: "40px 0px",
          })}
        >
          <Clients clients={clients} />
          <Testimonials testimonials={testimonials} />
        </Box>
      )}
    </>
  );
};
